import { useFormik } from "formik"
import InputSelect from "global/InputSelect/InputSelect"
import InputText from "global/InputText/InputText"
import Modal from "global/Modal/Modal"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { discountPercentage } from "global/Validation/Validation"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { getUrls } from "services/api.enums"
import { getAPI } from "services/CRUDServices"
import { paymentType } from "tools/data/EnumData"

interface DiscountModalProps {
  open: boolean
  setOpen: (value: boolean) => void
  setInvoice: any
  setDiscountPrice?: any
}

const DiscountModal = ({
  open,
  setOpen,
  setInvoice,
  setDiscountPrice,
}: DiscountModalProps) => {
  const [userPercent, setUserPercent] = useState()
  const { currenthub } = useSelector((state: any) => state.userInfo)
  const { orderManagementData } = useSelector((state: any) => state.orderData)

  useEffect(() => {
    try {
      getAPI(
        `/core-api/servicedeliveryservice/findPercentFromHub/${currenthub.id}/81/${orderManagementData?.senderCustomerId}`
      ).then((res) => {
        setUserPercent(res.data?.payload)
        setFieldValue("percent", res.data?.payload)
      })
    } catch (error: any) {}
  }, [])

  const {
    handleSubmit,
    handleChange,
    values,
    touched,
    errors,
    isSubmitting,
    setFieldValue,
  } = useFormik({
    validationSchema: discountPercentage(userPercent),
    initialValues: { percent: "", percentType: null},
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const res = await getAPI(
          `${getUrls.invoiceReportinfoPercentage}/${orderManagementData.orderId}/${values.percent}/81/${values.percentType?.id}`
        )
        setInvoice(res.data.payload)

        setDiscountPrice(values)
        setOpen(false)
      } catch (error) {
        setSubmitting(false)
      }
    },
  })

  return (
    <Modal
      visible={open}
      setVisible={setOpen}
      title='درصد تخفیف خود را وارد کنید'
    >
      <form onSubmit={handleSubmit}>
        <InputText
          label='درصد تخفیف'
          wrapperClassName='w-72'
          name='percent'
          handleChange={handleChange}
          values={values.percent}
          important
          error={touched.percent && errors.percent}
        />
        <InputSelect
          label='نوع تخفیف'
          important
          name='percentType'
          handleChange={setFieldValue}
          values={values.percentType}
          error={touched.percentType && errors.percentType}
          options={paymentType}
          wrapperClassName='w-full mt-4'
          // isDisabled
        />
        <SimpleButton
          className='full-tomato-btn mt-4 w-full'
          text='ثبت'
          type='submit'
          loading={isSubmitting}
          disabled={userPercent === 0}
        />
      </form>
    </Modal>
  )
}

export default DiscountModal
